import { Pipe, inject, PipeTransform } from "@angular/core";
import { DefinitionDisplayMode } from "@logex/framework/lg-application";
import { AsPipeBase } from "../bases/as-pipe-base";
import { AppDefinitions } from "../app-definitions.service";

@Pipe({
    name: "asSpecialism",
    standalone: false
})
export class AsSpecialismPipe extends AsPipeBase implements PipeTransform {
    constructor() {
        const _appDefinitions = inject(AppDefinitions);

        super(_appDefinitions, "specialism");
    }

    public transform(value: any, format?: DefinitionDisplayMode, empty?: string) {
        if (format === "custom") {
            const entry = this._appDefinitions.getEntry("specialism", value);
            return `${entry.display_code}-${entry.abbreviation ? entry.abbreviation : ""}`;
        } else {
            return super.transform(value, format, empty);
        }
    }
}
